export const NAMESPACE = "WikiPageViewer";

export const MOCK_BLOCKS = [
  {
    id: "0-drag-h1",
    type: "h1",
    text: "Heading 1",
    value: "<p>Welcome to Hugo's page!</p>",
    editing: false
  },
  {
    id: "1-drag-divider",
    type: "divider",
    text: "Divider",
    value: "",
    editing: false
  },
  {
    id: "4-drag-button",
    type: "button",
    text: "Button",
    value: "<p>Skip</p>",
    editing: false
  },
  {
    id: "2-drag-h3",
    type: "h3",
    text: "Heading 3",
    value: "<p>This is nature</p>",
    editing: false
  },
  {
    id: "3-drag-image",
    type: "image",
    text: "Image",
    value: "https://cdn.filestackcontent.com/YcApbhQM2Q7bkEr3ukIw",
    editing: false
  }
];
